import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  listSubjectCombinations,
  createSubjectCombination,
  updateSubjectCombination,
  listSubjects,
  getPeriodRulesDefault,
} from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

const HOCKY = [{ k: "hk1", label: "Học kỳ 1" }, { k: "hk2", label: "Học kỳ 2" }];
const LOAI = [{ k: "chon", label: "Lớp chọn" }, { k: "thuong", label: "Lớp thường" }];
const KHOIS = ["10", "11", "12"];
// Nhãn nhóm tuỳ chọn (chỉ để lọc hiển thị, không ảnh hưởng logic xếp TKB) —
// khớp 2 mục "Tổ hợp tự nhiên"/"Tổ hợp xã hội" trong hub Quản lý dạy học.
const GROUP_LABELS = { tunhien: "Tổ hợp tự nhiên", xahoi: "Tổ hợp xã hội" };
const GROUP_OPTIONS = [["", "— Chưa gán nhóm —"], ["tunhien", "Tự nhiên"], ["xahoi", "Xã hội"]];

const HappySchoolCombinations = () => {
  const { group } = useParams(); // "tunhien" | "xahoi" | undefined (xem tất cả)
  const schoolId = getActiveSchoolId();
  const [combos, setCombos] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [rules, setRules] = useState({});
  const [hocky, setHocky] = useState("hk1");
  const [loai, setLoai] = useState("chon");
  const [name, setName] = useState("");
  const [subjectIds, setSubjectIds] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const reload = () => {
    if (!schoolId) return;
    setLoading(true);
    Promise.all([listSubjectCombinations(schoolId), listSubjects(schoolId), getPeriodRulesDefault(schoolId)])
      .then(([c, s, r]) => {
        setCombos(c);
        setSubjects(s);
        setRules(r || {});
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(reload, [schoolId]);

  // Số tiết/tuần quy định cho 1 môn ở 1 khối (theo hocky/loai đang chọn) — tổng CK+TC+CĐ.
  const periodsFor = (khoi, subjectId) => {
    const cell = (((rules[hocky] || {})[loai] || {})[khoi] || {})[subjectId];
    if (!cell) return 0;
    return (Number(cell.ck) || 0) + (Number(cell.tc) || 0) + (Number(cell.cd) || 0);
  };

  if (!schoolId) {
    return (
      <div style={{ padding: 24 }}>
        Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link> trước.
      </div>
    );
  }

  const toggleSubject = (id) => {
    setSubjectIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await createSubjectCombination(schoolId, { name: name.trim(), subjectIds, group: group || "" });
      setName("");
      setSubjectIds([]);
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleToggleComboSubject = async (combo, subjectId) => {
    const next = combo.subjectIds.includes(subjectId)
      ? combo.subjectIds.filter((x) => x !== subjectId)
      : [...combo.subjectIds, subjectId];
    try {
      await updateSubjectCombination(schoolId, combo.id, { subjectIds: next });
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleRename = async (comboId, newName) => {
    if (!newName.trim()) return;
    try {
      await updateSubjectCombination(schoolId, comboId, { name: newName.trim() });
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleComboField = async (comboId, field, value) => {
    try {
      await updateSubjectCombination(schoolId, comboId, { [field]: value });
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const visibleCombos = group ? combos.filter((c) => c.group === group) : combos;

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
      {group && (
        <p style={{ margin: "0 0 6px" }}>
          <Link to="/happyschool/combinations" style={{ fontSize: 13, color: "#0ea5a3" }}>← Tất cả tổ hợp</Link>
        </p>
      )}
      <h2 style={{ margin: "0 0 8px 0" }}>{group ? GROUP_LABELS[group] || "Tổ hợp bộ môn" : "Tổ hợp bộ môn"}</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Mỗi tổ hợp gồm 1 danh sách môn học. Mỗi lớp chọn 1 tổ hợp ở trang "Lớp học".
        {group ? ` Đang lọc theo nhóm "${GROUP_LABELS[group]}" — đổi nhóm của từng tổ hợp bên dưới nếu cần.` : ""}
      </p>

      <div style={{ display: "flex", gap: 16, alignItems: "center", marginBottom: 16, flexWrap: "wrap" }}>
        <span style={{ fontSize: 13, color: "#6b7280" }}>Số tiết theo quy định — xem theo:</span>
        <div style={{ display: "flex", gap: 6 }}>
          {HOCKY.map((h) => (
            <button key={h.k} type="button" onClick={() => setHocky(h.k)} style={hocky === h.k ? tabBtnActive : tabBtn}>{h.label}</button>
          ))}
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          {LOAI.map((l) => (
            <button key={l.k} type="button" onClick={() => setLoai(l.k)} style={loai === l.k ? tabBtnActive : tabBtn}>{l.label}</button>
          ))}
        </div>
      </div>

      <form onSubmit={handleCreate} style={{ marginBottom: 24, padding: 16, border: "1px solid #e5e7eb", borderRadius: 8 }}>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Tên tổ hợp (vd: Tổ hợp 1)"
            style={{ flex: 1, padding: 8, border: "1px solid #d1d5db", borderRadius: 6 }}
          />
          <button type="submit" style={btnStyle}>
            Thêm tổ hợp
          </button>
        </div>
        {group && (
          <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 4px" }}>
            Tổ hợp mới sẽ được gán nhóm "{GROUP_LABELS[group]}".
          </p>
        )}
        <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
          {subjects.map((s) => (
            <label key={s.id} style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 4 }}>
              <input type="checkbox" checked={subjectIds.includes(s.id)} onChange={() => toggleSubject(s.id)} />
              {s.name}
            </label>
          ))}
        </div>
      </form>

      {error && <p style={{ color: "#dc2626" }}>{error}</p>}
      {loading ? (
        <p>Đang tải...</p>
      ) : visibleCombos.length === 0 ? (
        <p style={{ color: "#6b7280" }}>{group ? `Chưa có tổ hợp nào thuộc nhóm "${GROUP_LABELS[group]}".` : "Chưa có tổ hợp nào."}</p>
      ) : (
        visibleCombos.map((combo) => (
          <div key={combo.id} style={{ padding: 16, border: "1px solid #e5e7eb", borderRadius: 8, marginBottom: 12 }}>
            <div style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "center" }}>
              <input
                defaultValue={combo.name}
                onBlur={(e) => handleRename(combo.id, e.target.value)}
                style={{ flex: 1, padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontWeight: 600 }}
              />
              <select
                value={combo.group || ""}
                onChange={(e) => handleComboField(combo.id, "group", e.target.value)}
                style={{ padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13 }}
                title="Nhóm (chỉ để lọc hiển thị)"
              >
                {GROUP_OPTIONS.map(([v, l]) => (<option key={v} value={v}>{l}</option>))}
              </select>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
              {subjects.map((s) => (
                <label key={s.id} style={{ fontSize: 13, display: "flex", alignItems: "center", gap: 4 }}>
                  <input
                    type="checkbox"
                    checked={combo.subjectIds.includes(s.id)}
                    onChange={() => handleToggleComboSubject(combo, s.id)}
                  />
                  {s.name}
                </label>
              ))}
            </div>

            {combo.subjectIds.length > 0 && (
              <div style={{ overflowX: "auto", marginTop: 12 }}>
                <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={thStyle}>Môn</th>
                      {KHOIS.map((k) => (<th key={k} style={thStyle}>Khối {k}</th>))}
                    </tr>
                  </thead>
                  <tbody>
                    {subjects.filter((s) => combo.subjectIds.includes(s.id)).map((s) => (
                      <tr key={s.id}>
                        <td style={tdNameStyle}>{s.name}</td>
                        {KHOIS.map((k) => (<td key={k} style={tdStyle}>{periodsFor(k, s.id) || "—"}</td>))}
                      </tr>
                    ))}
                    <tr>
                      <td style={{ ...tdNameStyle, fontWeight: 700, background: "#f9fafb" }}>Tổng số tiết/tuần</td>
                      {KHOIS.map((k) => {
                        const total = subjects.filter((s) => combo.subjectIds.includes(s.id)).reduce((sum, s) => sum + periodsFor(k, s.id), 0);
                        return (<td key={k} style={{ ...tdStyle, fontWeight: 700, background: "#f9fafb" }}>{total}</td>);
                      })}
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 12 }}>
              <label style={{ fontSize: 13, display: "flex", flexDirection: "column", gap: 4, flex: "1 1 260px" }}>
                <span style={{ color: "#4b5563", fontWeight: 600 }}>Môn thi tốt nghiệp</span>
                <input
                  defaultValue={combo.examSubjects || ""}
                  onBlur={(e) => handleComboField(combo.id, "examSubjects", e.target.value)}
                  placeholder="vd: Toán, Văn, Sử, Địa"
                  style={fieldStyle}
                />
              </label>
              <label style={{ fontSize: 13, display: "flex", flexDirection: "column", gap: 4, flex: "1 1 260px" }}>
                <span style={{ color: "#4b5563", fontWeight: 600 }}>Chuyên đề</span>
                <input
                  defaultValue={combo.specializedTopics || ""}
                  onBlur={(e) => handleComboField(combo.id, "specializedTopics", e.target.value)}
                  placeholder="vd: Toán, Văn, Sử"
                  style={fieldStyle}
                />
              </label>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

const btnStyle = { padding: "8px 16px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600 };
const fieldStyle = { padding: 6, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13 };
const tabBtn = { padding: "5px 12px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 999, cursor: "pointer", fontWeight: 600, fontSize: 12 };
const tabBtnActive = { ...tabBtn, background: "#0ea5a3", color: "#fff", border: "1px solid #0ea5a3" };
const thStyle = { border: "1px solid #e5e7eb", padding: "4px 8px", background: "#f9fafb", textAlign: "center", whiteSpace: "nowrap" };
const tdStyle = { border: "1px solid #e5e7eb", padding: "4px 8px", textAlign: "center" };
const tdNameStyle = { ...tdStyle, textAlign: "left", fontWeight: 600 };

export default HappySchoolCombinations;
